import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { forEach } from 'lodash'

import { batchRevealAnimation } from '@/components/sections/animations/shared'

import { Animation } from '@/types'

export const downloadRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const items = selector('[data-motion-item]')

  let itemsBatchAnimation: ScrollTrigger[]
  if (items.length) {
    itemsBatchAnimation = batchRevealAnimation({
      targets: items,
      reverse,
      delay,
      stagger: { amount: 0.24 }
    })
  }

  return () => {
    forEach(itemsBatchAnimation || [], (animation) => animation.kill())
  }
}
